import { render, staticRenderFns } from "./open-loading.vue?vue&type=template&id=c0855eb0&scoped=true&lang=pug&"
import script from "./open-loading.vue?vue&type=script&lang=js&"
export * from "./open-loading.vue?vue&type=script&lang=js&"
import style0 from "./open-loading.vue?vue&type=style&index=0&id=c0855eb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0855eb0",
  null
  
)

export default component.exports